import { Fragment } from "react";
import { Tooltip } from "../../../../components";
import Link from "next/link";
import { StyledBlueSpan } from "./Success.styles";

const ListContent = {
  Line1: (
    <Fragment>
      You can now find and
      <Tooltip tooltipName="manageBooking">
        <StyledBlueSpan> update </StyledBlueSpan>
      </Tooltip>
      this ticket request in your profile under
      <Link href="/profile?tab=tickets">
        <StyledBlueSpan> Applications & Tickets </StyledBlueSpan>.
      </Link>
    </Fragment>
  ),
  Line2: (
    <Fragment>
      Ticket offers are usually sent out
      <Tooltip tooltipName="lastMinuteTickets">
        <StyledBlueSpan> 1 to 2 weeks </StyledBlueSpan>
      </Tooltip> 
      before the show date.
    </Fragment>
  ),
  Line3: (
    <Fragment>
      You and your guests will have a 
      <Tooltip tooltipName="ticketOfferExpiration">
        <StyledBlueSpan> limited time </StyledBlueSpan>
      </Tooltip> 
      to accept.
    </Fragment>
  ),
};

export const ListArray: React.ReactElement[] = [
  ListContent.Line1,
  ListContent.Line2,
  ListContent.Line3,
];
